var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCapacitacaoHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2388_5174",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2388_5174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4729 17.5556C23.3089 17.5556 23.1742 17.5026 23.0688 17.3968C22.9634 17.291 22.9107 17.1675 22.9107 17.0265V9.23104L12.369 14.9453C12.2284 15.0394 12.0761 15.1041 11.9122 15.1393C11.7482 15.1746 11.5959 15.1922 11.4553 15.1922C11.2914 15.1922 11.1332 15.1746 10.981 15.1393C10.8287 15.1041 10.6706 15.0511 10.5066 14.9806L0.491947 9.44268C0.327965 9.34862 0.210835 9.22516 0.140557 9.07231C0.0702784 8.91946 0.0234261 8.76073 0 8.59612C0 8.43151 0.0409957 8.2669 0.122987 8.10229C0.204978 7.93768 0.327965 7.82011 0.491947 7.74956L10.4715 2.24691C10.6354 2.17637 10.7994 2.11758 10.9634 2.07055C11.1274 2.02352 11.2914 2 11.4553 2C11.6193 2 11.7775 2.02352 11.9297 2.07055C12.082 2.11758 12.2284 2.18813 12.369 2.28219L23.4729 8.31393C23.6369 8.408 23.7657 8.53145 23.8594 8.6843C23.9532 8.83715 24 8.99588 24 9.16049V17.0265C24 17.1675 23.9473 17.291 23.8419 17.3968C23.7365 17.5026 23.6135 17.5556 23.4729 17.5556ZM11.4553 22C11.2914 22 11.1274 21.9765 10.9634 21.9295C10.7994 21.8824 10.6354 21.8119 10.4715 21.7178L3.83016 18.1199C3.54905 17.9318 3.31479 17.6849 3.12738 17.3792C2.93997 17.0735 2.84627 16.7325 2.84627 16.3563V11.6296L10.0849 15.6155C10.2958 15.7331 10.5183 15.833 10.7526 15.9153C10.9868 15.9976 11.2211 16.0388 11.4553 16.0388C11.6662 16.0388 11.8887 15.9976 12.123 15.9153C12.3572 15.833 12.5798 15.7331 12.7906 15.6155L20.0293 11.6296V16.3563C20.0293 16.7325 19.9414 17.0735 19.7657 17.3792C19.59 17.6849 19.3499 17.9318 19.0454 18.1199L12.369 21.7178C12.2284 21.8119 12.082 21.8824 11.9297 21.9295C11.7775 21.9765 11.6193 22 11.4553 22Z",
    fill: "#58C5C6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapacitacaoHover);
export default __webpack_public_path__ + "static/media/capacitacao_hover.f016028f4569f3f3ba78f122448ec079.svg";
export { ForwardRef as ReactComponent };